import { AWFilterList, UserPreferenceShareResponse } from '@blk/awt-userpreference';
import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { EnumPrefixConfig, prefixEnumsForAGraph } from '../../utils/ApiUtils';
import { isAGraphEnabled } from './AGraphUtils';
import { userPreferenceApi } from './Base';

export const fetchSavedFilterLists = async (pkg: string) => {
  const path = '/v1/filters';
  const response = await userPreferenceApi.get<AGraphWrappedType<AWFilterList[], 'filters'>>(path, { params: { pkg } });
  return unwrapAGraphResponse(response, 'filters');
};

const AGRAPH_REQUEST_ENUM_PREFIXES: EnumPrefixConfig[] = [
  { fieldNames: ['operator'], prefix: 'FILTER_OPERATOR_', recursiveFieldPatterns: ['filters'] },
  { fieldNames: ['valueType'], prefix: 'FILTER_VALUE_TYPE_', recursiveFieldPatterns: ['filters'] },
];

export const postSavedFilterList = async (filterList: AWFilterList, pkg: string) => {
  const path = '/v1/filters';
  const payload = isAGraphEnabled() ? prefixEnumsForAGraph(filterList, AGRAPH_REQUEST_ENUM_PREFIXES) : filterList;
  const response = await userPreferenceApi.post<AGraphWrappedType<string, 'result'>>(path, payload, {
    params: { pkg },
  });
  return unwrapAGraphResponse(response, 'result');
};

export const shareSavedFilterList = (pkg: string, id: string, withUsers: string) => {
  const path = `/v1/filters/${id}/_share`;
  return userPreferenceApi.post<UserPreferenceShareResponse>(path, isAGraphEnabled() ? {} : undefined, {
    params: { pkg, withUsers },
  });
};

export const putSavedFilterList = async (filterList: AWFilterList, id: string, pkg: string) => {
  const payload = isAGraphEnabled() ? prefixEnumsForAGraph(filterList, AGRAPH_REQUEST_ENUM_PREFIXES) : filterList;
  const path = `/v1/filters/${id}`;
  const response = await userPreferenceApi.put<AGraphWrappedType<string, 'result'>>(path, payload, {
    params: { pkg },
  });
  return unwrapAGraphResponse(response, 'result');
};

export const deleteSavedFilterList = (id: string, pkg: string) => {
  const path = `/v1/filters/${id}`;
  return userPreferenceApi.delete(path, { params: { pkg } });
};
